import { render } from "./branch-details.vue?vue&type=template&id=6fbb2d2d"
import script from "./branch-details.vue?vue&type=script&lang=js"
export * from "./branch-details.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__